export default __webpack_public_path__ + "static/media/ge6.14fbde99.jpg";